// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import VModal from 'vue-js-modal/dist/ssr.nocss';
import Notifications from 'vue-notification';
import VueAxe from 'vue-axe';
import { sync } from 'vuex-router-sync';
import VCalendar from 'v-calendar';
import VueGtm from 'vue-gtm';
import VueWait from 'vue-wait';
import Vuelidate from 'vuelidate';
import Clipboard from 'v-clipboard';

import { library } from '@fortawesome/fontawesome-svg-core';

import faAngleLeft from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-light/faAngleLeft';
import faAngleRight from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-light/faAngleRight';
import faColumns from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-light/faColumns';
import faCopy from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-light/faCopy';
import faFolder from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-light/faFolder';
import faNewspaper from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-light/faNewspaper';
import faPencilAlt from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-light/faPencilAlt';
import faPlusCircle from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-light/faPlusCircle';
import faQuestionCircle from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-light/faQuestionCircle';
import faSearch from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-light/faSearch';
import faTimes from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-light/faTimes';
import falEdit from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-light/faEdit';

import faCalendar from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-regular/faCalendar';
import faImage from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-regular/faImage';
import farTimes from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-regular/faTimes';
import farCheckCircle from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-regular/faCheckCircle';
import farExclamationTriangle from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-regular/faExclamationTriangle';

import faBars from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faBars';
import faBook from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faBook';
import faCaretDown from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faCaretDown';
import faChalkboardTeacher from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faChalkboardTeacher';
import faChartBar from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faChartBar';
import faCheck from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faCheck';
import faCheckCircle from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faCheckCircle';
import faCog from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faCog';
import faComments from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faComments';
import faDownload from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faDownload';
import faEdit from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faEdit';
import faEllipsisH from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faEllipsisH';
import faEllipsisV from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faEllipsisV';
import faExclamationTriangle from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faExclamationTriangle';
import faFile from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faFile';
import faFilter from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faFilter';
import faPencil from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faPencil';
import faSlidersH from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faSlidersH';
import faSort from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faSort';
import faSortDown from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faSortDown';
import faSortUp from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faSortUp';
import faArrowAltRight from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faArrowAltRight';
import fasPlusCircle from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faPlusCircle';
import fasTimes from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faTimes';
import fasTimesCircle from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faTimesCircle';
import faSync from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faSync';
import faSchool from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faSchool';
import faStar from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faStar';
import faUser from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faUser';
import faUserFriends from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faUserFriends';
import faUserPlus from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faUserPlus';
import faPlus from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faPlus';
import faUsers from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faUsers';
import faUserTimes from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faUserTimes';
import faVideo from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faVideo';
import faExternalLinkAlt from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faExternalLinkAlt';
import faChevronCircleLeft from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faChevronCircleLeft';
import faChevronCircleRight from 'font-awesome-pro/advanced-options/use-with-node-js/fontawesome-pro-solid/faChevronCircleRight';
import { faUsersClass } from 'font-awesome-pro/advanced-options/use-with-node-js/pro-solid-svg-icons/faUsersClass';

import App from './App';
import router from './router';
import store from './store';

import './assets/styles/main.scss';
import './assets/styles/vue-voxy.scss';

library.add(
  faAngleLeft,
  faAngleRight,
  faBars,
  faCalendar,
  faCaretDown,
  faChalkboardTeacher,
  faChartBar,
  faCheck,
  faCheckCircle,
  farCheckCircle,
  faCog,
  faColumns,
  faComments,
  faCopy,
  faDownload,
  faEdit,
  falEdit,
  faEllipsisV,
  faExclamationTriangle,
  farExclamationTriangle,
  faExternalLinkAlt,
  faFile,
  faFilter,
  faFolder,
  faImage,
  faNewspaper,
  faPencil,
  faPencilAlt,
  faPlusCircle,
  faQuestionCircle,
  faTimes,
  farTimes,
  fasTimes,
  fasTimesCircle,
  faSearch,
  faSlidersH,
  faSort,
  faSortDown,
  faSortUp,
  faArrowAltRight,
  fasPlusCircle,
  faSync,
  faSchool,
  faStar,
  faUser,
  faUserFriends,
  faUserPlus,
  faPlus,
  faUsers,
  faUserTimes,
  faVideo,
  faBook,
  faEllipsisH,
  faChevronCircleLeft,
  faChevronCircleRight,
  faUsersClass,
);

Vue.use(Clipboard);

Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

Vue.use(Notifications);

Vue.use(VCalendar, {
  datePickerSelectColor: '#1bcbdd',
  datePickerDragColor: '#1bcbdd',
  datePickerShowDayPopover: false,
});

const googleAnalyticsId = process.env.GOOGLE_ANALYTICS_ID;
Vue.use(VueAnalytics, {
  id: googleAnalyticsId,
  router,
});

Vue.use(VueGtm, {
  debug: false,
});

Vue.use(VueWait);

Vue.use(Vuelidate);

sync(store, router);

if (process.env.NODE_ENV === 'development') {
  Vue.use(VueAxe);
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  wait: new VueWait({ useVuex: true }),
});
